<template>
  <el-dialog
    class="contract-detail-dialog common-dialog"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
  >
    <el-form
      ref="formDate"
      :model="formDate"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item label="合约名称" prop="contractName" class="str-input">
        <el-input v-model="formDate.contractName" placeholder="" disabled></el-input>
      </el-form-item>

      <el-form-item label="合约版本" prop="contractVersion" class="form-item-character">
        <el-input v-model="formDate.contractVersion" placeholder="" disabled></el-input>
      </el-form-item>

      <el-form-item label="虚拟机类型" prop="runtimeType">
        <el-select v-model="formDate.runtimeType" placeholder="请选择" disabled class="auto-width">
          <el-option v-for="ele in options" :key="ele.value" :label="ele.label" :value="ele.value">
          </el-option>
        </el-select>
        <div class="tips">
          目前只有v2.1.0版本及以上的chainmaker支持docker_go，请确保您的链版本在V2.1.0以上，且开启docker-vm，详情可见开源文档
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="deployContract()">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'Index',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 100
  },
  data() {
    return {
      title: '查看合约',
      dialogVisible: false,
      options: [],
      formDate: {
        chainId: '',
        ContractName: '',
        contractVersion: '',
        runtimeType: null
      },
      adaptationVars: {
        formLabelWidth: 100
      },
      chainId: ''
    }
  },
  watch: {
    '$store.state.computing.chainId': {
      deep: true,
      handler(val) {
        this.chainId = val
      }
    }
  },
  mounted() {
    this.chainId = this.$store.state.computing.chainId
    this.getOptions()
  },
  methods: {
    getOptions() {
      //获取虚拟机类型
      this.$apis.chain.getRuntimeTypeList().then(res => {
        if (res.data) {
          let arr = res.data.items
          let newArr = arr.map(ele => {
            let item = {
              label: ele.RuntimeTypeName,
              value: ele.RuntimeTypeType
            }
            return item
          })
          this.options = newArr
        }
      })
    },
    deployContract() {
      let params = {
        chainid: this.chainId
      }
      this.$apis.encryption.contractInstall(params).then(res => {
        if (res) {
          this.$message({
            type: 'success',
            message: '部署成功'
          })
        }
      })
    },

    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen(data) {
      this.formDate = data
      this.dialogVisible = true
    }
  }
}
</script>

<style scoped lang="scss">
.contract-detail-dialog {
  /deep/ .el-dialog {
    width: var(--common-dialog-medium-width);
  }

  .el-form {
    margin-right: var(--common-dialog-form-margin-right);
  }
}
</style>
